import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '~components/ui/select';

type BlockPropertySelectProps = {
  /** Currently selected block property, e.g., 'hardness', 'depth' */
  selectedBlockProperty: string;
  /** Callback when block property changes */
  onBlockPropertyChange: (property: string) => void;
};

/**
 * Dropdown selector for choosing a block property to colour by
 */
const BlockPropertySelect = ({ selectedBlockProperty, onBlockPropertyChange }: BlockPropertySelectProps) => {
  return (
    <>
      <h3 className="font-bold text-foreground text-lg">Colour Blocks By</h3>
      <Select value={selectedBlockProperty} onValueChange={(value) => onBlockPropertyChange(value)}>
        <SelectTrigger className="w-full text-sm">
          <SelectValue placeholder="Select a parameter" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="hardness">Hardness</SelectItem>
          <SelectItem value="depth">Depth</SelectItem>
          <SelectItem value="strand">Strand</SelectItem>
          <SelectItem value="material">Material</SelectItem>
          <SelectItem value="mineralisation_value">Mineralisation</SelectItem>
          <SelectItem value="density">Density</SelectItem>
          <SelectItem value="fe">Fe</SelectItem>
          <SelectItem value="geology">Geology</SelectItem>
        </SelectContent>
      </Select>
    </>
  );
};

export { BlockPropertySelect };
